import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

/* @TODO: Remove Outline Element because it doesn't seem to add value? */
@customElement('outline-element')
export class OutlineElement extends LitElement {}
declare global {
  interface HTMLElementTagNameMap {
    'outline-element': OutlineElement;
  }
}
